import React from 'react';

import { neptuneUrls } from '@neptune/shared/common-domain';
import { ErrorPlaceholder } from '@neptune/shared/common-ui';

type ErrorPlaceholderContainerProps = Omit<
  React.ComponentProps<typeof ErrorPlaceholder>,
  'statusPageUrl'
> & {
  context: string;
};

export const ErrorPlaceholderContainer: React.FC<ErrorPlaceholderContainerProps> = ({
  context,
  ...restProps
}) => {
  return <ErrorPlaceholder statusPageUrl={neptuneUrls.statusPage} {...restProps} />;
};
